import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const EmailHeadersApi = {
  getHeaders(id) {
    return http
      .get(`${teamPath()}/emails/${id}/rendered`, {
        params: { type: 'headers' },
      })
      .then((response) => response.data.data);
  },
};
